import { create } from "zustand";

export const useInstanceState = create<{
    instanceId: string;
    setInstanceId: (instanceId: string) => void;
  }>((set) => ({
    instanceId: "",
    setInstanceId: (instanceId) => set((state) => ({ instanceId: instanceId }))
}));